var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramColorful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28063_21261)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28063_21261",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 30C23.7843 30 30.5 23.2843 30.5 15C30.5 6.71573 23.7843 0 15.5 0C7.21573 0 0.5 6.71573 0.5 15C0.5 23.2843 7.21573 30 15.5 30Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28063_21261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.94531 60.7031C24.7436 60.7031 39.1719 46.2748 39.1719 28.4766C39.1719 10.6783 24.7436 -3.75 6.94531 -3.75C-10.8529 -3.75 -25.2812 10.6783 -25.2812 28.4766C-25.2812 46.2748 -10.8529 60.7031 6.94531 60.7031Z",
    fill: "url(#paint0_radial_28063_21261)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7188 11.9531C20.366 11.9531 20.8906 11.4285 20.8906 10.7812C20.8906 10.134 20.366 9.60938 19.7188 9.60938C19.0715 9.60938 18.5469 10.134 18.5469 10.7812C18.5469 11.4285 19.0715 11.9531 19.7188 11.9531Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.25C14.7583 11.25 14.0333 11.4699 13.4166 11.882C12.7999 12.294 12.3193 12.8797 12.0355 13.5649C11.7516 14.2502 11.6774 15.0042 11.8221 15.7316C11.9668 16.459 12.3239 17.1272 12.8484 17.6516C13.3728 18.1761 14.041 18.5333 14.7684 18.6779C15.4958 18.8226 16.2498 18.7484 16.9351 18.4645C17.6203 18.1807 18.206 17.7001 18.618 17.0834C19.0301 16.4667 19.25 15.7417 19.25 15C19.25 14.0054 18.8549 13.0516 18.1517 12.3483C17.4484 11.6451 16.4946 11.25 15.5 11.25ZM15.5 16.875C15.1292 16.875 14.7667 16.765 14.4583 16.559C14.15 16.353 13.9096 16.0601 13.7677 15.7175C13.6258 15.3749 13.5887 14.9979 13.661 14.6342C13.7334 14.2705 13.912 13.9364 14.1742 13.6742C14.4364 13.412 14.7705 13.2334 15.1342 13.161C15.4979 13.0887 15.8749 13.1258 16.2175 13.2677C16.5601 13.4096 16.853 13.65 17.059 13.9583C17.265 14.2666 17.375 14.6292 17.375 15C17.375 15.4973 17.1775 15.9742 16.8258 16.3258C16.4742 16.6775 15.9973 16.875 15.5 16.875Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1875 7.5H10.8125C9.2592 7.5 8 8.7592 8 10.3125V19.6875C8 21.2408 9.2592 22.5 10.8125 22.5H20.1875C21.7408 22.5 23 21.2408 23 19.6875V10.3125C23 8.7592 21.7408 7.5 20.1875 7.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_28063_21261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.94531 28.4766) scale(32.2266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2A454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F05C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C22F86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6666AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5C6CB2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28063_21261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramColorful);
export default __webpack_public_path__ + "static/media/instagram-colorful.a4fab30a.svg";
export { ForwardRef as ReactComponent };